import React from "react";
import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby";

const query = graphql`
query BreadCrumbs {
  site {
    siteMetadata {
      title
    }
  }
}`

const BreadCrumbs = ({ infos }) => {
  const { site } = useStaticQuery(query);
  const siteName = site.siteMetadata.title;
  if (infos.type === "home") {
    return (<></>);
  }
  let crumbs = [];
  crumbs.push({
    tag: "a",
    uri: "/",
    title: siteName
  });
  (infos.ancestors || []).forEach(e => {
    crumbs.push({
      tag: "a",
      uri: "/"+e.path,
      title: e.name
    });
  });
  crumbs.push({
    tag: "span",
    title: infos.title
  });
  return (
    <div id="breadcrumbs">
      <ol role="navigation" aria-label="You are here: " itemScope="" itemType="https://schema.org/BreadcrumbList">
        { crumbs.map((e,i) => {
          return (
            <li itemProp="itemListElement" itemScope="" itemType="https://schema.org/ListItem" key={i}>
              { (e.tag === "a")
                ? (<Link
                  itemScope=""
                  itemType="https://schema.org/Thing"
                  itemProp="item"
                  to={ e.uri }
                  itemID={ e.uri }>
                  <span itemProp="name">
                    { e.title }
                  </span>
                </Link>)
                : (<span
                  itemScope=""
                  itemType="https://schema.org/Thing"
                  itemProp="item"
                  itemID={ e.uri }>
                  <span itemProp="name">
                    { e.title }
                  </span>
                </span>
                )
              }
              <meta itemProp="position" content={i+1} />
            </li>
          );
        })
        }
      </ol>
    </div>
  );
};

export default BreadCrumbs;
